/* Build in libraries */

/* Third party libraries */
import { FolderPlusIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { Layout } from '@/components/Layout';
import { LayoutCard, LayoutCardContent, LayoutCardTitle } from '@/components/LayoutCard';
import Button from '@/components/UI/Button';
/* Components */
import { NewProjectTemplate, ProjectTemplatesList } from '@/features/ProjectTemplates';

/* Services */
import { useProjectTemplates } from '@/hooks/ReactQueryHooks/useProjectTemplateQuery';
import { usePermission } from '@/hooks/usePermission';

const ProjectTemplates = () => {
  const [showModal, setShowModal] = useState({
    newTemplateForm: false,
  });
  const fetchProjectTemplates = useProjectTemplates({});
  const projectTemplatesCount = fetchProjectTemplates?.data?.meta?.count;
  const { hasPermission } = usePermission();

  const handleModal = () => {
    setShowModal((prevState) => ({
      ...prevState,
      newTemplateForm: !prevState.newTemplateForm,
    }));
  };

  const addNewTemplateBtn = (
    <>
      <Button label='New Template' icon={<PlusIcon className='h-5 w-5' />} btnStyle='btn-primary' type='button' onClick={handleModal} />
    </>
  );

  return (
    <>
      <Layout>
        <LayoutCard>
          <LayoutCardTitle title='Project Templates' actions={hasPermission(['CREATE_PROJECT_TEMPLATE']) && addNewTemplateBtn} />
          <LayoutCardContent>
            {projectTemplatesCount === 0 && (
              <div className='text-center h-screen/2 flex flex-col justify-center items-center'>
                <FolderPlusIcon className='h-12 w-12 text-neutralColor-light' />
                <h3 className='mt-1'>No project templates</h3>
                {hasPermission(['CREATE_PROJECT_TEMPLATE']) && (
                  <>
                    <p className='text-neutralColor-normal mb-5'>Get started to create project template.</p>
                    {addNewTemplateBtn}
                  </>
                )}
              </div>
            )}
            {projectTemplatesCount > 0 && <ProjectTemplatesList />}
          </LayoutCardContent>
        </LayoutCard>
      </Layout>
      {showModal.newTemplateForm && <NewProjectTemplate handleModal={handleModal} />}
    </>
  );
};

export default ProjectTemplates;
